/* Lifestyle-Distressed template only (templates/product.lifestyle-distressed.json).
   Loaded by snippets/doc-head-core.liquid when template.suffix == 'lifestyle-distressed'.
   Same behaviour as 2026-10-15 (theme "CA - Schema image fix - CPS warranty link (draft)"),
   for pop-up block pop_up_MBUUhH:
   1. Inline "Learn More" next to the warranty checkbox; opens the existing pop-up.
   2. A cleaner pop-up: check icons, the money-back note at the top, and an
      "Add to my order" bar that ticks the same warranty checkbox.
   The checkbox itself is still handled by assets/variant-warranty.js (unchanged).
   If anything is missing, the page keeps the original layout. */
(function () {
  var OPENER = 'modal-opener[data-modal="modal-pop_up_MBUUhH"]';
  var MODAL_ID = 'modal-pop_up_MBUUhH';
  var CHECKBOX = '#warranty-info-output input[type="checkbox"]';

  function addLink() {
    var opener = document.querySelector(OPENER);
    var out = document.getElementById('warranty-info-output');
    if (!opener || !out) return;
    var label = out.querySelector('label');
    if (!label) return;
    if (out.querySelector('.cps-learn-more')) return;

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'cps-learn-more';
    link.textContent = 'Learn More';
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-label', 'Learn more about the CPS Extended Warranty');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = opener.querySelector('button');
      if (btn) btn.click();
    });

    label.insertAdjacentElement('afterend', link);
    out.classList.add('cps-inline');
    document.documentElement.classList.add('cps-inline-learn-more');
  }

  function enhanceModal() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || modal.dataset.cpsEnhanced) return;
    var win = modal.querySelector('.modal__window');
    var content = modal.querySelector('.modal__content');
    if (!win || !content) return;
    modal.dataset.cpsEnhanced = '1';
    modal.classList.add('cps-modal');

    content.querySelectorAll('img[alt="Check"]').forEach(function (img) {
      var s = document.createElement('span');
      s.className = 'cps-check';
      s.setAttribute('role', 'img');
      s.setAttribute('aria-label', 'Covered');
      s.innerHTML = '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="#1f7a4d"/><path d="M5.6 10.4l2.9 2.9 5.9-6.3" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      img.replaceWith(s);
    });

    var note = null;
    Array.prototype.forEach.call(content.children, function (el) {
      if (/in store credit/i.test(el.textContent)) note = el;
    });
    if (note) {
      note.classList.add('cps-note');
      note.innerHTML = note.innerHTML.replace(/\bdont\b/g, 'don\u2019t').replace(/\bwont\b/g, 'won\u2019t');
      var title = content.querySelector('.h2');
      if (title) title.insertAdjacentElement('afterend', note);
    }

    var footer = document.createElement('div');
    footer.className = 'cps-modal-footer';
    footer.innerHTML = '<div class="cps-modal-footer__price"></div><button type="button" class="cps-modal-footer__add"></button>';
    win.appendChild(footer);
    var priceEl = footer.querySelector('.cps-modal-footer__price');
    var addBtn = footer.querySelector('.cps-modal-footer__add');

    function getBox() { return document.querySelector(CHECKBOX); }

    function sync() {
      var c = getBox();
      if (!c) { footer.hidden = true; return; }
      footer.hidden = false;
      var label = c.closest('label');
      var m = label ? label.textContent.match(/\$[\d,]+(?:\.\d{2})?/) : null;
      priceEl.textContent = '5-Year CPS Extended Warranty' + (m ? ' \u00b7 ' + m[0] : '');
      addBtn.textContent = c.checked ? 'Added \u2713  Remove' : 'Add to my order';
      addBtn.classList.toggle('is-added', c.checked);
    }

    addBtn.addEventListener('click', function () {
      var c = getBox();
      if (!c) return;
      c.checked = !c.checked;
      c.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      if (c.checked) {
        var close = modal.querySelector('.js-close-modal');
        if (close) setTimeout(function () { close.click(); }, 400);
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches(CHECKBOX)) sync();
    });
    new MutationObserver(sync).observe(modal, { attributes: true, attributeFilter: ['open'] });
    sync();
  }

  function init() {
    var out = document.getElementById('warranty-info-output');
    if (!document.querySelector(OPENER)) return;
    enhanceModal();
    if (!out) return;
    addLink();
    new MutationObserver(addLink).observe(out, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
